module.exports = __webpack_public_path__ + "images/marketing/btn_google_signin_light_normal_web.png";